var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.6 18.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 3.58,
    cy: 3.43,
    r: 3.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16.16,
    cy: 3.43,
    r: 3.43
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 3.43,
    cy: 15.34,
    r: 3.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16.02,
    cy: 15.34,
    r: 3.43
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoolIcon);
export default __webpack_public_path__ + "static/media/poolIcon.fac8414792c2c9abae0849fa44d9d6e8.svg";
export { ForwardRef as ReactComponent };